export default __webpack_public_path__ + "static/media/img2.b4a8edfb.png";